/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Table_Total_Events_HeaderInputs */

const en_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Events`)
};

const fr_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total des evenements`)
};

const de_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtereignisse`)
};

const it_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi totali`)
};

const ru_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всего событий`)
};

const es_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

const zh_cn2_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总事件`)
};

const ja_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計イベント数`)
};

const hi_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुल घटनाएँ`)
};

const pt_pt2_explorer_table_total_events_header = /** @type {(inputs: Explorer_Table_Total_Events_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total de eventos`)
};

/**
* | output |
* | --- |
* | "Total Events" |
*
* @param {Explorer_Table_Total_Events_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_table_total_events_header = /** @type {((inputs?: Explorer_Table_Total_Events_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Table_Total_Events_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_table_total_events_header(inputs)
	if (locale === "de") return de_explorer_table_total_events_header(inputs)
	if (locale === "it") return it_explorer_table_total_events_header(inputs)
	if (locale === "ru") return ru_explorer_table_total_events_header(inputs)
	if (locale === "es") return es_explorer_table_total_events_header(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_table_total_events_header(inputs)
	if (locale === "ja") return ja_explorer_table_total_events_header(inputs)
	if (locale === "hi") return hi_explorer_table_total_events_header(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_table_total_events_header(inputs)
	return en_explorer_table_total_events_header(inputs)
});